var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstructions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "instructions") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "instructions",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.0606061,-4.61852778e-14 L26.0595429,-4.61852778e-14 C27.1641124,-4.63881839e-14 28.0595429,0.8954305 28.0595429,2 L28.0595429,47.5396067 C28.0595429,48.6441762 27.1641124,49.5396067 26.0595429,49.5396067 L24.0606061,49.5396067 C22.9560366,49.5396067 22.0606061,48.6441762 22.0606061,47.5396067 L22.0606061,2 C22.0606061,0.8954305 22.9560366,-4.59823717e-14 24.0606061,-4.61852778e-14 Z M19.1578948,7.25677833 L19.1578948,18.8676237 L5.80542266,18.8676237 L0,13.062201 L5.80542266,7.25677833 L19.1578948,7.25677833 Z M30.8421052,30.4931588 L30.8421052,18.8823135 L44.1945773,18.8823135 L50,24.6877361 L44.1945773,30.4931588 L30.8421052,30.4931588 Z",
    id: "Combined-Shape",
    fill: "#383838"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstructions);
export default __webpack_public_path__ + "static/media/instructions.9f7dc4555f2c9289408ccbb7efe04dc0.svg";
export { ForwardRef as ReactComponent };